import {NgModule} from '@angular/core';
import {AgGridModule} from 'ag-grid-angular';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {DsSendungskorrekturComponent} from './ds-sendungskorrektur.component';
import {KorrekturModule} from '../sendungskorrektur/korrektur/korrektur.module';

@NgModule({
  declarations: [DsSendungskorrekturComponent],
  imports: [
    CollapseModule,
    AgGridModule,
    FontAwesomeModule,
    KorrekturModule
  ],
  exports: [DsSendungskorrekturComponent]
})
export class DsSendungskorrekturModule {
}
